import React from "react";

const SortContext = React.createContext();

export default SortContext;
